require('../src/app/landing_page');
